var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: { hasOverlay: _vm.isMenuOpened } },
    [
      _c(
        "slick",
        {
          ref: "slick",
          attrs: { options: _vm.slickOptions },
          on: {
            init: _vm.handleSlickChange,
            afterChange: _vm.handleSlickChange
          }
        },
        [_vm._t("default")],
        2
      ),
      _vm._v(" "),
      _c("div", { staticClass: "slick__pagination" }, [
        _vm.slick
          ? _c(
              "div",
              { staticClass: "slick__pagination__wrapper" },
              _vm._l(_vm.slick.slideCount, function(i) {
                return _c("span", {
                  key: i,
                  staticClass: "slick__pagination__item",
                  class: { active: i === _vm.slick.currentSlide + 1 },
                  on: {
                    click: function($event) {
                      _vm.slick.goTo(i - 1)
                    }
                  }
                })
              }),
              0
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _vm._m(0)
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "scroll__indicator" }, [
      _c("span", [_vm._v("Scroll")]),
      _vm._v(" "),
      _c("span", { staticClass: "scroll__indicator__line" })
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-59ca20d8", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// /var/www/costimise/wp-content/themes/costimise/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-59ca20d8","hasScoped":false,"optionsId":"0","buble":{"objectAssign":"Object.assign","transforms":{}}}!/var/www/costimise/wp-content/themes/costimise/node_modules/vue-loader/lib/selector.js?type=template&index=0!./scripts/vue/hero-slider/HeroSlider.vue
// module id = 156
// module chunks = 0